import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class WorkspaceNotificationDTO {
  @Expose()
  id: number;

  @Expose()
  autopostError: boolean;

  @Expose()
  autopostSuccess: boolean;

  @Expose()
  marketing: boolean;

  @Expose()
  postReminder: boolean;

  @Expose()
  workspaceId: number;
}
